import React from "react";
import {
  ConfigProvider,
  theme,
  Card,
  Button,
  Progress,
  Typography,
  Row,
  Col,
  Statistic,
} from "antd";
import "./ColorTest.scss";

const { Title, Text } = Typography;

// Refined palette
const palette = {
  orange: "#FF6B01",
  dark: "#0F0F0F",
  white: "#FFFFFF",
  border: "#F1F1F1",
  secondaryText: "rgba(15, 15, 15, 0.45)",
};

const ColorTest: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: palette.orange,
          colorBgBase: palette.white,
          colorTextBase: palette.dark,
          colorTextSecondary: palette.secondaryText,
          colorBorder: palette.border, // ← Global border color (used by Card, Button, etc.)
          colorBgContainer: palette.white,
          borderRadius: 4,
        },
        components: {
          Button: {
            borderRadius: 4,
            controlHeight: 40,
            fontWeight: 600,
            colorPrimaryHover: "#FF8A3D",
            colorPrimaryActive: "#E55F00",
          },
          Card: {
            boxShadow: "none", // Valid – removes shadow
            // NO 'border' key here – it's controlled by colorBorder global token
          },
          Progress: {
            colorInfo: palette.orange,
          },
          Typography: {
            colorTextHeading: palette.dark,
          },
        },
      }}
    >
      <div className="color-test-container">
        <Title
          level={2}
          style={{
            textAlign: "center",
            marginBottom: "48px",
            color: palette.dark,
            letterSpacing: "-0.02em",
          }}
        >
          Tally — Industrial Premium Test
        </Title>

        {/* Navbar: white + thin border */}
        <div className="navbar-mock">
          <div className="logo">Tally</div>
          <div className="nav-links">
            <span>Dashboard</span>
            <span>Customers</span>
            <span>Slips</span>
            <span>Rewards</span>
            <span>Settings</span>
          </div>
        </div>

        <Row gutter={[24, 24]} style={{ marginTop: "40px" }}>
          <Col xs={24} md={8}>
            <Card title="Today's Sales">
              <Statistic
                title="Revenue"
                value={248500}
                prefix="₦"
                valueStyle={{ color: palette.dark, fontSize: 32 }}
              />
              <Text type="secondary">+14% this week</Text>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card title="Reward Progress">
              <Progress
                percent={78}
                status="active"
                strokeColor={palette.orange}
              />
              <div style={{ marginTop: 12 }}>
                <Text type="secondary">12 customers near reward</Text>
              </div>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card title="Quick Actions">
              <Button
                type="primary"
                block
                style={{ marginBottom: 16, height: 44 }}
              >
                Generate New Slips
              </Button>

              <Button
                block
                style={{
                  height: 44,
                  borderColor: palette.orange,
                  color: palette.orange,
                }}
              >
                Send Broadcast
              </Button>
            </Card>
          </Col>
        </Row>

        {/* Swatches */}
        <div style={{ marginTop: "64px" }}>
          <Title
            level={4}
            style={{ textAlign: "center", marginBottom: "32px" }}
          >
            Palette Swatches
          </Title>
          <div className="swatches">
            <div
              className="swatch"
              style={{ background: palette.orange, color: palette.white }}
            >
              Orange Accent
              <br />
              #FF6B01
            </div>
            <div
              className="swatch"
              style={{ background: palette.dark, color: palette.white }}
            >
              Ink Dark
              <br />
              #0F0F0F
            </div>
            <div
              className="swatch"
              style={{
                background: palette.white,
                color: palette.dark,
                border: `1px solid ${palette.border}`,
              }}
            >
              White Base
              <br />
              #FFFFFF
            </div>
            <div
              className="swatch"
              style={{ background: palette.border, color: palette.dark }}
            >
              Border
              <br />
              #F1F1F1
            </div>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
};

export default ColorTest;
